<template>
  <a-card>
    <div style="text-align: right;">
      <span class="ant-descriptions-title" style="float: left; margin-top: 5px;">
        <a-icon type="appstore" /> Danh sách người dùng
      </span>
      <a-button style="margin-right: 10px;" icon="export" @click="showExport">
        Export
      </a-button>
      <a-button slot="extra" type="primary" @click="() => (visibleAddItem = true)">
        <a-icon type="user-add" /> Thêm
      </a-button>
    </div>

    <a-drawer v-if="visibleAddItem" title="Thêm người dùng" placement="right" :visible="visibleAddItem"
      @close="() => (visibleAddItem = false)" :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }">
      <AddEmployee :closeDrawer="() => (visibleAddItem = false)" :updateListAfterCreated="updateListAfterCreated"
        style="margin-bottom: 10px;" />
    </a-drawer>

    <a-table :pagination="{
      current: currentPage,
      onChange: (page) => {
        this.currentPage = page;
      },
    }" :columns="columnEmployee" :data-source="listEmployee" rowKey="id" :loading="loading" size="small"
      :scroll="{ x: 1500, y: 425 }" class="employee-table">
      <div slot="title">
        <a-row :gutter="[8, 8]">
          <a-col :sm="24" :md="6">
            <div class="search-employee-content">
              <a-input v-model="keySearch" placeholder="Tìm nhân viên theo tên, mã, email ..." style="width: 100%;"
                @change="onFilter" />
            </div>
          </a-col>

          <a-col :sm="24" :md="6">
            <div class="select-department">
              <SelectDepartment @change="onFilter" v-model="departmentIds" :selectProps="{
                style: { width: '100%' },
                placeholder: 'Phòng ban',
              }" />
            </div>
          </a-col>

          <a-col :sm="24" :md="6">
            <div class="select-position">
              <SelectPosition v-model="positionId" @change="onFilter" :selectProps="{
                style: { width: '100%' },
                placeholder: 'Chức vụ',
              }" />
            </div>
          </a-col>

          <a-col :sm="24" :md="4">
            <div class="select-status">
              <a-select allowClear placeholder="Trạng thái" v-model="status" style="width: 100%;" @change="onFilter">
                <a-select-option value="ACTIVE">
                  ACTIVE
                </a-select-option>
                <a-select-option value="DEACTIVE">
                  DEACTIVE
                </a-select-option>
              </a-select>
            </div>
          </a-col>

          <a-col :sm="24" :md="2" style="text-align: right;">
            <a-button type="dashed" @click="resetFilter" :disabled="isDisabledResetFilter" style="margin-left: auto;">
              Bỏ lọc
            </a-button>
          </a-col>
        </a-row>
      </div>

      <div slot="code" slot-scope="text, record">
        <a @click="goToItem(record)">{{ record.code }}</a>
      </div>

      <div slot="fullname" slot-scope="text, record">
        <a @click="goToItem(record)">{{ record.fullname }}</a>
      </div>
      <div slot="employee" slot-scope="text">
        <a v-if="text && text.id" @click="goToEmployee(text)">{{
          text.fullname
        }}</a>
      </div>
      <div slot="status" slot-scope="text, record">
        <p v-if="record.status === 'ACTIVE'">
          <a-icon type="check" style="marginleft: 5px; color: #52c419;" />
        </p>
        <p v-else>
          <a-icon type="stop" style="marginleft: 5px; color: #f10b0b;" />
        </p>
      </div>
      <div slot="action" slot-scope="text, record" style="text-align: center;">
        <a-button icon="info-circle" @click="goToItem(record)" class="icon-update">
          Chi tiết
        </a-button>
      </div>
      <div slot="footer">
        <a-button type="link" @click="pagination" :disabled="isDisabledPagination" :loading="loading">
          <a-icon type="reload" /> Tải thêm
        </a-button>
      </div>
    </a-table>
  </a-card>
</template>
<script>
import debounce from "lodash/debounce";
import changeAlias from "@/services/changeAlias";
import getQuery from "../data/getData";
import AddEmployee from "./addUser";
import SelectPosition from "@/components/common/position/select";
import SelectDepartment from "@/components/common/department/select";
import { updateForCreated } from "@/services/updateOnViewConfig";

const limit = 10;
const startPage = 1;

const columnEmployee = [
  {
    title: "Username",
    dataIndex: "username",
    scopedSlots: { customRender: "username" },
    sorter: (employeeA, employeeB) => {
      var codeA = employeeA.username.toUpperCase();
      var codeB = employeeB.username.toUpperCase();
      if (codeA > codeB) {
        return -1;
      }
      if (codeA < codeB) {
        return 1;
      }
      return 0;
    },

    width: 120,
    sortDirections: ["descend"],
    fixed: "left",
  },
  {
    title: "Tên",
    dataIndex: "fullname",
    scopedSlots: { customRender: "fullname" },
    sorter: (employeeA, employeeB) => {
      var fullnameA = employeeA.fullname.toUpperCase();
      var fullnameB = employeeB.fullname.toUpperCase();
      if (fullnameA > fullnameB) {
        return -1;
      }
      if (fullnameA < fullnameB) {
        return 1;
      }
      return 0;
    },
    width: 200,
    sortDirections: ["descend"],
  },
  {
    title: "Trạng thái",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
    ellipsis: true,
    align: "center",
    width: 200,
  },
  {
    title: "Email",
    dataIndex: "email",
    scopedSlots: { customRender: "email" },
    ellipsis: true,
    width: 200,
  },

  {
    title: "Phòng ban",
    dataIndex: "department.name",
    scopedSlots: { customRender: "department" },
    width: 200,
  },
  {
    title: "Chức vụ",
    dataIndex: "position.name",
    scopedSlots: { customRender: "position" },
    width: 200,
  },

  {
    title: "Nhân viên",
    dataIndex: "employee",
    scopedSlots: { customRender: "employee" },
    width: 150,
  },
  {
    title: "Admin of location",
    dataIndex: "adminOfLocation.name",
    scopedSlots: { customRender: "adminOfLocationId" },
    width: 150,
  },
  {
    title: "",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 100,
    fixed: "right",
  },
];

export { columnEmployee };

export default {
  components: { AddEmployee, SelectPosition, SelectDepartment },
  data() {
    this.onFilter = debounce(this.onFilter, 800);
    return {
      currentPage: startPage,
      isDisabledPagination: false,
      loading: true,
      columnEmployee,
      listEmployee: [],
      departmentIds: undefined,
      positionId: undefined,
      status: undefined,
      gender: undefined,
      keySearch: undefined,
      checkNotFilter: true,
      isDisabledResetFilter: true,
      visibleAddItem: false,
    };
  },
  methods: {
    searchFilter(input, option) {
      return (
        changeAlias(option.componentOptions.children[0].text).indexOf(
          changeAlias(input)
        ) >= 0
      );
    },
    onDefaultCurrentPage() {
      this.currentPage = 1;
      this.listEmployee = [];
    },
    goToDetailUser(record) {
      this.$router.push({
        name: "detailUser",
        params: { idUser: record.id },
      });
    },
    goToItem(record) {
      this.$router.push({
        name: "basicInfoUser",
        params: { idUser: record.id },
      });
    },
    goToEmployee(record) {
      this.$router.push({
        name: "basicInfoEmployee",
        params: { idEmployee: record.id },
      });
    },
    pagination() {
      this.currentPage += 1;
      this.getAllUser();
    },
    checkDisableButtonNotFilter() {
      if (
        !this.departmentIds &&
        !this.positionId &&
        !this.gender &&
        !this.keySearch &&
        !this.status
      ) {
        this.isDisabledResetFilter = true;
      }
    },
    isFilterEmployees() {
      if (
        !this.departmentIds &&
        !this.positionId &&
        !this.gender &&
        !this.keySearch &&
        !this.status
      ) {
        return false;
      }
      return true;
    },
    resetFilter() {
      if (this.isFilterEmployees()) {
        this.departmentIds = undefined;
        this.positionId = undefined;
        this.status = undefined;
        this.gender = undefined;
        this.keySearch = undefined;
        this.isDisabledPagination = false;
        this.isDisabledResetFilter = true;
        this.onDefaultCurrentPage();
        this.getAllUser();
      }
    },
    onFilter(e) {
      this.isDisabledResetFilter = false;
      this.onDefaultCurrentPage();
      this.checkDisableButtonNotFilter();
      this.getAllUser();
    },
    getAllUser() {
      this.loading = true;
      this.$apollo
        .query({
          query: getQuery.queryGetAllUser,
          variables: {
            limit,
            page: this.currentPage,
            query: this.keySearch,
            gender: this.gender,
            positionId: this.positionId,
            departmentIds: this.departmentIds,
            status: this.status,
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.users?.length >= 0) {
            if (data.users.length < limit) {
              this.isDisabledPagination = true;
            } else {
              this.isDisabledPagination = false;
            }

            this.listEmployee = [...this.listEmployee.concat(data.users)];
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách người dùng", error);
        });
    },

    updateListAfterCreated(item) {
      this.listEmployee = updateForCreated({
        item,
        list: this.listEmployee,
        limit: limit,
        currentPage: this.currentPage,
      });
    },
    showExport() {
      const url = new URL('./#/employee/export', window.location.href);
      console.log(url)
      window.open(url.toString());
    }
  },
  created() {
    this.getAllUser();
  },
};
</script>
